var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 483,
    viewBox: "0 0 483 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_2229_20339)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.978,
    y: 100.98,
    width: 281.045,
    height: 281.045,
    rx: 140.522,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.978,
    y: 100.98,
    width: 281.045,
    height: 281.045,
    rx: 140.522,
    fill: "url(#paint0_radial_2229_20339)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.627,
    y: 101.63,
    width: 279.745,
    height: 279.745,
    rx: 139.872,
    stroke: "white",
    strokeWidth: 1.29963
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.242 221.875C215.877 221.36 216.451 220.785 216.966 220.15C219.202 218.459 221.581 216.909 225.157 216.558C226.354 216.558 227.552 216.558 228.749 216.558C243.078 217.755 236.752 236.22 234.353 246.59C233.637 249.687 231.937 255.583 234.784 257.08C235.738 257.581 237.94 257.657 239.239 257.224C242.369 256.181 244.525 251.899 245.418 249.033C246.175 246.603 246.581 243.71 247.142 240.986C248.715 233.35 250.586 224.15 252.172 216.989C256.866 217.085 261.943 216.797 266.398 217.133C264.178 228.852 261.548 240.16 259.213 251.763C258.975 252.058 258.975 253.337 259.213 253.631C259.129 255.679 259.978 256.794 261.224 257.511C269.34 257.042 269.947 248.719 271.571 241.417C273.283 233.71 275.011 224.347 276.744 216.989C281.438 217.085 286.515 216.797 290.97 217.133C287.938 232.541 284.464 247.509 281.342 262.828C288.282 260.906 291.604 255.366 293.843 248.745C295.185 248.745 296.526 248.745 297.868 248.745C295.173 258.073 290.097 265.02 280.337 267.282C278.462 279.011 275.683 289.835 263.524 291.279C261.944 291.279 260.363 291.279 258.782 291.279C253.761 290.504 250.484 287.987 249.873 282.801C249.873 282.083 249.873 281.365 249.873 280.645C250.078 277.929 251.25 276.179 252.46 274.467C253.094 273.952 253.669 273.377 254.184 272.742C257.482 270.197 261.438 268.31 265.967 266.994C266.424 265.391 266.772 263.68 267.117 261.965C264.898 264.01 261.868 266.488 257.633 266.994C256.148 266.994 254.663 266.994 253.178 266.994C248.634 266.174 245.929 263.515 245.132 258.947C244.212 259.753 243.65 260.915 242.833 261.821C242.246 262.288 241.719 262.815 241.252 263.403C239.044 265.122 236.687 266.693 233.061 266.995C231.624 266.995 230.187 266.995 228.75 266.995C223.306 266.26 220.287 263.1 219.554 257.654C219.554 256.409 219.554 255.164 219.554 253.919C220.455 246.006 223.003 239.741 223.865 231.79C224.103 231.401 224.103 230.023 223.865 229.634C223.84 227.744 223.07 226.597 221.997 225.754C221.464 225.856 221.38 225.509 220.847 225.611C220.692 225.373 219.565 225.373 219.41 225.611C212.811 227.827 212.036 237.485 210.501 244.866C208.956 252.298 207.214 259.758 205.903 266.277C203.107 266.414 194.405 266.693 191.677 266.133C193.902 254.132 196.693 242.697 199.005 230.784C199.244 230.442 199.244 229.113 199.005 228.772C198.831 226.305 197.369 224.789 194.407 225.611C191.464 226.427 189.641 229.997 188.516 233.226C187.294 236.733 186.821 240.743 186.073 244.147C184.296 252.231 182.722 259.736 181.331 266.277C178.535 266.414 169.834 266.693 167.105 266.133C170.37 249.567 173.965 233.333 177.451 216.989C182.193 216.989 186.935 216.989 191.677 216.989C191.677 217.133 191.677 217.276 191.677 217.42C191.5 218.776 191.083 219.892 190.958 221.3C191.409 221.384 192.142 220.562 192.826 220.006C194.933 218.296 197.632 216.548 201.592 216.414C202.215 216.414 202.837 216.414 203.46 216.414C203.699 216.414 203.939 216.414 204.178 216.414C209.392 216.853 212.116 219.781 212.944 224.605C213.75 224.293 214.437 222.663 215.242 221.875ZM259.213 283.52C263.244 281.803 264.036 276.847 264.961 272.024C261.929 273.276 255.799 275.463 255.334 279.641C255.126 281.491 256.148 283.267 257.776 283.52C257.931 283.758 259.058 283.758 259.213 283.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.392 236.387C318.803 236.563 318.844 244.266 314.392 244.434C313.913 244.434 313.434 244.434 312.955 244.434C311.109 244.076 309.938 243.044 309.65 241.129C309.65 240.65 309.65 240.171 309.65 239.692C309.964 237.803 311.066 236.701 312.955 236.387C313.434 236.387 313.913 236.387 314.392 236.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.858 239.691C321.009 235.798 328.059 235.731 328.186 239.691C328.307 240.049 328.374 240.461 328.33 240.985C328.213 244.974 321.091 245.166 320.858 241.128C320.858 240.649 320.858 240.17 320.858 239.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.181 250.041C327.247 250.491 327.055 250.683 326.606 250.616C326.159 250.22 326.784 249.594 327.181 250.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.6 250.47C325.412 250.655 325.07 250.655 324.882 250.47C324.82 250.17 324.98 250.09 325.025 249.896C325.475 249.829 325.666 250.021 325.6 250.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.714 253.92C320.754 255.274 318.213 255.497 317.983 254.207C318.625 253.705 318.695 254.769 319.564 254.494C320.105 254.46 320.125 253.905 320.283 253.488C320.011 253.32 319.613 254.249 318.702 253.919C316.289 252.466 320.024 249.362 320.714 252.195C320.714 252.771 320.714 253.345 320.714 253.92ZM318.415 252.771C318.829 254.555 321.21 252.512 319.708 251.62C319.068 251.241 318.206 251.869 318.415 252.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.163 253.922C324.176 255.29 321.707 255.47 321.432 254.209C322.089 253.731 322.208 254.811 323.157 254.496C323.409 254.364 323.656 254.229 323.588 253.778C322.541 254.193 321.268 253.66 321.289 252.484C321.317 250.973 323.76 250.303 324.163 252.198C324.163 252.772 324.163 253.347 324.163 253.922ZM322.008 251.767C321.511 255.755 325.963 251.11 322.008 251.767V251.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.758 251.047C304.426 251.385 304.479 252.338 304.908 252.915C305.482 252.531 305.452 251.543 306.058 251.191C306.495 251.589 305.782 252.532 305.483 253.202C305.182 253.877 304.996 255.117 304.19 255.07C304.226 254.484 304.561 254.196 304.764 253.777C304.651 252.739 303.391 252.087 303.758 251.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.597 249.895C301.123 249.895 301.65 249.895 302.178 249.895C303.573 250.596 302.722 251.79 303.184 253.344C302.833 253.424 302.877 253.9 302.322 253.775C301.699 253.775 301.076 253.775 300.454 253.775C300.538 252.518 300.276 250.915 300.597 249.895ZM300.884 250.326C300.884 250.709 300.884 251.091 300.884 251.475C301.642 251.467 302.595 251.654 302.465 250.757C302.369 250.181 301.54 250.34 300.884 250.326ZM301.171 252.05C300.692 251.442 300.558 253.145 300.885 253.343C301.656 253.3 302.719 253.55 302.753 252.768C302.842 251.913 301.927 252.061 301.171 252.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.037 253.778C327.004 253.961 326.608 253.966 326.606 253.778C326.606 252.916 326.606 252.054 326.606 251.191C327.521 251.282 326.815 252.994 327.037 253.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.567 239.408C296.012 237.339 297.555 235.477 299.591 235.097C306.514 233.804 309.079 244.439 301.602 245.731C301.123 245.731 300.644 245.731 300.166 245.731C297.582 245.345 296.115 243.842 295.567 241.42C295.567 240.749 295.567 240.079 295.567 239.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.374 253.486C311.374 253.534 311.374 253.582 311.374 253.63C309.297 254.622 307.76 253.005 308.213 251.187C308.542 249.87 310.826 249.064 311.519 250.612C310.831 250.794 310.81 250.239 310.082 250.325C308.347 250.531 308.072 253.751 310.656 253.343C311.28 253.439 311.043 252.676 311.088 252.194C310.761 252.088 309.967 252.452 310.082 251.906C310.235 251.58 310.985 251.851 311.375 251.762C311.375 251.81 311.375 251.858 311.375 251.906C311.374 252.432 311.374 252.959 311.374 253.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.811 251.19C313.21 251.048 314.235 250.835 314.247 251.478C313.833 251.495 313.307 251.399 313.098 251.621C312.936 251.651 312.874 251.781 312.811 251.908C312.48 252.248 312.759 253.198 312.667 253.776C312.667 253.824 312.667 253.872 312.667 253.92C312.5 253.943 312.411 253.888 312.38 253.776C312.602 252.993 311.896 251.281 312.811 251.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.254 252.768C315.149 253.159 315.539 253.056 315.54 253.342C316.128 253.491 316.925 253.11 317.122 253.342C316.724 254.376 315.099 253.78 314.679 253.199C313.863 250.659 317.685 250.299 317.409 252.624C317.361 252.624 317.313 252.624 317.265 252.624C316.64 252.716 315.641 252.437 315.254 252.768ZM315.254 252.049C314.639 252.531 317.235 252.386 316.834 252.193C316.937 251.401 315.327 251.428 315.254 252.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.025 253.634C325.241 252.892 324.551 251.243 325.457 251.191C325.457 252.054 325.457 252.916 325.457 253.778C325.457 253.826 325.457 253.874 325.457 253.922C325.21 253.928 325.084 253.815 325.025 253.634Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_dddddd_2229_20339)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 241.499,
    r: 165.54,
    stroke: "#F2F2F2",
    strokeWidth: 1.94944
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter2_dddddd_2229_20339)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 241.5,
    r: 191.533,
    stroke: "#F2F2F2",
    strokeWidth: 1.94944
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04,
    filter: "url(#filter3_dddddd_2229_20339)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 241.5,
    r: 217.525,
    stroke: "#F2F2F2",
    strokeWidth: 1.94944
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_2229_20339",
    x: 78.8453,
    y: 78.8482,
    width: 325.309,
    height: 325.309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.263479
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.526959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2229_20339",
    result: "effect2_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2229_20339",
    result: "effect3_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.68871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2229_20339",
    result: "effect4_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3235
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2229_20339",
    result: "effect5_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0661
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2229_20339",
    result: "effect6_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2229_20339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddddd_2229_20339",
    x: 52.8531,
    y: 52.8521,
    width: 377.294,
    height: 377.294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.263479
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.526959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2229_20339",
    result: "effect2_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2229_20339",
    result: "effect3_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.68871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2229_20339",
    result: "effect4_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3235
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2229_20339",
    result: "effect5_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0661
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2229_20339",
    result: "effect6_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2229_20339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddddd_2229_20339",
    x: 26.8604,
    y: 26.8599,
    width: 429.279,
    height: 429.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.263479
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.526959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2229_20339",
    result: "effect2_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2229_20339",
    result: "effect3_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.68871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2229_20339",
    result: "effect4_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3235
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2229_20339",
    result: "effect5_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0661
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2229_20339",
    result: "effect6_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2229_20339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddddd_2229_20339",
    x: 0.867737,
    y: 0.867737,
    width: 481.265,
    height: 481.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.263479
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.526959
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2229_20339",
    result: "effect2_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2229_20339",
    result: "effect3_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.68871
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2229_20339",
    result: "effect4_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3235
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2229_20339",
    result: "effect5_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0661
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2229_20339",
    result: "effect6_dropShadow_2229_20339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2229_20339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2229_20339",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.5 241.503) rotate(90.0206) scale(451.621)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB952",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsLogo);
export default __webpack_public_path__ + "static/media/about-us-logo.9b0d5c73a6185fbafe867cb308e13c1a.svg";
export { ForwardRef as ReactComponent };